<template>
    <bscroll-view>
        <div class="changepassword-view user-common-view">
            <div class="action-block">
                <p class="action-header">
                    {{ langTransfer('修改密码') }}
                </p>
                <div class="active-item">
                    <h5>
                        {{ langTransfer('原始密码') }}
                    </h5>
                    <input v-model="passwordForm.oldPassword"
                           :placeholder="langTransfer('请输入原始密码')"
                           type="password"
                    >
                </div>
                <div class="active-item">
                    <h5>
                        {{ langTransfer('新密码') }}
                    </h5>
                    <input v-model="passwordForm.password"
                           :placeholder="langTransfer('请输入新密码')"
                           type="password"
                    >
                </div>
                <div class="active-item">
                    <h5>
                        {{ langTransfer('确认密码') }}
                    </h5>
                    <input v-model="passwordForm.passwordSure"
                           :placeholder="langTransfer('请确认新密码')"
                           type="password"
                    >
                </div>
                <button class="main-btn"
                        @click="changePassword"
                >
                    {{ langTransfer('确认修改') }}
                </button>
            </div>
        </div>
    </bscroll-view>
</template>

<script>
    import BscrollView from '@/components/bscrollView'
    import { patchPassword } from '@/api/hb'

    export default {
        name: 'ChangePWD',
        components: {
            BscrollView
        },
        data () {
            return {
                fileReader: new FileReader(),
                passwordForm: {
                    oldPassword: '',
                    password: '',
                    passwordSure: ''
                },
                inPatch: false
            }
        },
        computed: {
            user_unique_code () {
                return this.$store.state.user_unique_code
            },
            webInfo () {
                return this.$store.state.webInfo
            },
            pageSetup () {
                return this.$store.state.pageSetup
            },
            userInfo () {
                return this.$store.state.userInfo
            }
        },
        created () {
        },
        methods: {
            async changePassword () {
                const isRight = this.validator()
                if (!isRight || this.inPatch) {
                    return
                }
                try {
                    const { passwordForm } = this
                    const formData = {
                        service_code: this.webInfo.service_code,
                        user_unique_code: this.user_unique_code,
                        old_app_pwd: passwordForm.oldPassword,
                        new_app_pwd: passwordForm.password
                    }
                    this.inPatch = true
                    const data = await patchPassword(formData)
                    this.inPatch = false
                    if (typeof data === 'object') {
                        this.$message({
                            message: this.langTransfer('修改成功'),
                            type: 'success'
                        })
                    }
                    this.passwordForm = {
                        oldPassword: '',
                        password: '',
                        passwordSure: ''
                    }
                    this.$cookies.remove('user_unique_code')
                    this.$store.commit('setShowLoginRegister', true)
                    this.$store.commit('setMustLogin', true)
                } catch (error) {
                    const { message } = error
                    this.inPatch = false
                    this.$message.error(message)
                }
            },
            validator () {
                const { passwordForm } = this
                let hasAllVal = true
                for (const key in passwordForm) {
                    if (Object.hasOwnProperty.call(passwordForm, key)) {
                        const val = passwordForm[key]
                        if (!val) {
                            hasAllVal = false
                        }
                    }
                }
                if (!hasAllVal) {
                    this.$message.error(this.langTransfer('请输入完整信息'))
                    return hasAllVal
                }
                if (this.isSamePassword()) {
                    hasAllVal = false
                    this.$message.error(this.langTransfer('新密码不能与旧密码一致'))
                    return hasAllVal
                }
                if (!this.isPassword()) {
                    hasAllVal = false
                    this.$message.error(this.langTransfer('密码长度不能少于6个字符'))
                    return hasAllVal
                }
                if (!this.isSurePassword()) {
                    hasAllVal = false
                    this.$message.error(this.langTransfer('两次输入的密码不一致'))
                    return hasAllVal
                }
                return hasAllVal
            },
            isSamePassword () {
                const { oldPassword, password } = this.passwordForm
                return oldPassword === password
            },
            isPassword () {
                const { password } = this.passwordForm
                return password.length >= 6
            },
            isSurePassword () {
                const { password, passwordSure } = this.passwordForm
                return passwordSure === password
            }
        }
    }
</script>
